class MSizeChart extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      openButton: '[data-open-size-chart]',
      content: '.m-product-size-chart',
      container: '.m-product-addon'
    };
  }

  connectedCallback() {
    this.domNodes = queryDomNodes(this.selectors, this);
    this.container = document.querySelector(this.selectors.container);

    if (this.domNodes.content && this.domNodes.content.innerHTML) {
      this.content = this.domNodes.content.innerHTML;
      this.init();
    }
  }

  init() {
    this.modal = new MinimogTheme.Modal();

    addEventDelegate({
      selector: this.selectors.openButton,
      handler: (e) => {
        e.preventDefault();

        if (this.content) {
          const html = document.createElement("DIV");
          html.innerHTML = this.content;
          this.modal.appendChild(html);
          
          this.modal.setWidth('600px');
          this.modal.setSizes(`m-form-size-chart`);
          this.container.classList.remove('m\:hidden');

          this.modal.open();
        }
      }
    });
  }
}

customElements.define('m-size-chart', MSizeChart);
